<template>
  <div class="article-content" ref="articleContent">
    <div
      :ref="`taskList-${i}`"
      :class="item.active ? 'active article-items' : 'article-items'"
      v-for="(item, i) in taskList"
      :key="i"
      @click="clickTask(item, i)"
    >
      <div class="task-title">
        <span
          :class="{
            'orange-theme': item.taskStatus === 3,
            'blue-theme': item.taskStatus === 4,
            'dannger-theme': item.taskStatus === 5
          }"
          >{{ item.taskStatusText }}</span
        >
        {{ item.taskName }}
      </div>
      <div class="task-flex">
        <div class="task-key">数量:</div>
        <div class="task-value">{{ item.count }}</div>
      </div>
      <div class="task-flex">
        <div class="task-key">结算方式:</div>
        <div class="task-value">{{ item.unitPriceYuan }}</div>
      </div>
      <div class="task-flex">
        <div class="task-key">任务截止时间:</div>
        <div class="task-value">{{ item.endTime }}</div>
      </div>
      <div class="task-flex">
        <div class="task-key">委托时间:</div>
        <div class="task-value">{{ item.createTime }}</div>
      </div>
      <div class="flex-end">
        <el-button size="small" @click.stop="checkInfo(item)" type="text">查看任务明细</el-button>
      </div>
    </div>
    <el-dialog
      title="任务明细"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="766px"
      :before-close="() => (dialogVisible = false)"
      custom-class="theme-dialog task-info-dialog"
    >
      <div class="wrap-files">
        <div class="task-flex">
          <div class="task-key">任务名称:</div>
          <div class="task-value">{{ details.taskName }}</div>
        </div>
        <div class="task-flex">
          <div class="task-key">数量:</div>
          <div class="task-value">{{ details.count }}</div>
        </div>
        <div class="task-flex">
          <div class="task-key">结算方式:</div>
          <div class="task-value">{{ details.unitPriceYuan }}</div>
        </div>
        <div class="task-flex">
          <div class="task-key">截止时间:</div>
          <div class="task-value">{{ details.endTime }}</div>
        </div>
        <div class="task-flex">
          <div class="task-key">描述:</div>
          <div class="task-value">{{ details.description }}</div>
        </div>
        <div class="task-flex">
          <div class="task-key">执行要求:</div>
          <div class="task-value">{{ details.executionRequirement }}</div>
        </div>
        <div class="task-flex">
          <div class="task-key">质控要求:</div>
          <div class="task-value">{{ details.qualityControlStandard }}</div>
        </div>
        <div class="task-flex">
          <div class="task-key">结算标准:</div>
          <div class="task-value">{{ details.settleStandard }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const routeKey = 'proxy-task'
import { getStore, setStore } from '@dygc/shared'
import { request } from '@/api/request'
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
      dialogVisible: false,
      taskList: [
        // {
        //   taskId:1,
        //   active: true,
        //   taskName:'任务名称',
        //   taskStatus:3, // 任务状态（3：待承接，4:已承接，5:已拒接，6:已完成)
        //   surveyStatusText:'已关闭', // 任务状态
        //   count:'执行100份',// 数量
        //   unitPriceYuan:'按答卷结算,每份10元', // 结算方式
        //   endTime:'2020-09-09 18:00', // 截止时间
        //   createTime:'2020-09-09 18:00',// 委托时间
        // },
      ],
      details: {
        // taskName:'任务名称',
        // count:'100 份',
        // unitPriceYuan:'按天结算，每天 10 元',
        // endTime:'2020-09-09 19:00',
        // createTime:'2020-09-09 19:00',
        // description:'这里是内容的详情，会出现换行的情况这里是内容的详情，会出现换行的情况这里是内容的详情，会出现换行的情况这里是内容的详情，会出现换行的情况这里是内容的详情，会出现换行的情况',
        // executionRequirement:'执行要求',
        // qualityControlStandard:'质控要求',
        // settleStandard:'结算标准',
      }
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler: function (oldVal, newVal) {
        oldVal.taskId && setStore({ name: 'taskId', content: oldVal.taskId })
        oldVal.agentTenantId && setStore({ name: 'agentTenantId', content: oldVal.agentTenantId })
      }
    }
  },
  computed: {},
  methods: {
    clickTask(item, index) {
      this.taskList = this.taskList.map((it, i) => ({
        ...it,
        active: i === index ? true : false
      }))
      const taskId = this.$route.query.taskId || getStore({ name: 'taskId' })
      // 当选中的任务不为当前任务 执行路由跳转
      if (item.taskId !== taskId) {
        // 3 待承接 4已承接
        if (item.taskStatus === 3 || item.taskStatus === 5) {
          this.$router.push({
            name: `${routeKey}-task-details`,
            query: { taskId: item.taskId, agentTenantId: this.$route.query.agentTenantId || getStore({ name: 'agentTenantId' }) }
          })
        } else if (item.taskStatus === 4) {
          this.$router.push({
            name: `${routeKey}-investigator-list`,
            query: { taskId: item.taskId, agentTenantId: this.$route.query.agentTenantId || getStore({ name: 'agentTenantId' }) }
          })
        }
        setStore({ name: 'taskStatus', content: item.taskStatus })
      }
    },
    checkInfo(item) {
      this.getTaskDetails(item)
      this.dialogVisible = true
    },
    getTaskList() {
      request
        .get('/quota/wjmyentrust/taskList', {
          params: {
            agentTenantId: this.$route.query.agentTenantId || getStore({ name: 'agentTenantId' }),
            surveyId: this.$route.params.id
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            data.data.forEach(it => {
              if (it.endTime && it.createTime) {
                it.endTime = it.endTime
                  .split(':')
                  .slice(0, 2)
                  .reduce((prev, curt, i) => (i === 1 ? (prev += `:${curt}`) : (prev += curt)), '')
                it.createTime = it.createTime
                  .split(':')
                  .slice(0, 2)
                  .reduce((prev, curt, i) => (i === 1 ? (prev += `:${curt}`) : (prev += curt)), '')
              }
              const taskId = this.$route.query.taskId || getStore({ name: 'taskId' })
              it.active = it.taskId === Number(taskId) ? true : false
              if (it.taskId === Number(taskId)) {
                setStore({ name: 'taskStatus', content: it.taskStatus })
              }
              switch (it.taskStatus) {
                case 3:
                  it.taskStatusText = '待承接'
                  break
                case 4:
                  it.taskStatusText = '已承接'
                  break
                case 5:
                  it.taskStatusText = '已拒接'
                  break
                default:
                  break
              }
            })
            this.taskList = data.data
            this.$nextTick(() => {
              // 获取当前选中的任务 的下标
              const index = this.taskList.findIndex(it => it.active)
              // 获取当前选中的左侧任务距离父级容器的top 距离
              const offsetTop = this.$refs[`taskList-${index}`][0].offsetTop - 80
              // 设置滚动条到当前距离
              this.$refs.articleContent.scrollTo(0, offsetTop)
            })
          }
        })
    },
    getTaskDetails(item) {
      request
        .post(`/quota/wjmyentrust/getTaskInfoById/`, {
          taskId: item.taskId,
          agentTenantId: this.$route.query.agentTenantId || getStore({ name: 'agentTenantId' })
        })
        .then(({ data }) => {
          if (data.code === 0 && data.data) {
            for (let key in data.data) {
              if (key === 'endTime' || key === 'createTime') {
                data.data[key] =
                  data.data[key] &&
                  data.data[key]
                    .split(':')
                    .slice(0, 2)
                    .reduce((prev, curt, i) => (i === 1 ? (prev += `:${curt}`) : (prev += curt)), '')
              }
            }
            this.details = data.data
          }
        })
    }
  },
  created() {},
  mounted() {
    this.getTaskList()
  }
}
</script>
<style lang="scss" scoped>
.article-content {
  width: 100%;
  height: 100%;
  overflow: auto;
  .article-items {
    padding: 12px;
    border-bottom: 1px solid #f7f9fb;
    &.active {
      background: rgba(39, 117, 232, 0.1);
    }
    .task-title {
      margin-bottom: 6px;
      max-height: 34px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 13px;
      line-height: 17px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      color: rgba(0, 0, 0, 0.85);
      span {
        display: inline-block;
        width: 42px;
        height: 17px;
        background: rgba(39, 117, 232, 0.15);
        border-radius: 1.59px;
        text-align: center;
        font-style: normal;
        font-size: 12px;
        margin-right: 3px;
        @apply text-theme;
        &.blue-theme {
          background: rgba(39, 117, 232, 0.15);
          @apply text-theme;
        }
        &.orange-theme {
          color: #e8a31b;
          background: rgba(232, 163, 27, 0.15);
        }
        &.dannger-theme {
          color: #e34152;
          background: rgba(227, 65, 82, 0.15);
        }
      }
    }
    .task-flex {
      display: flex;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      margin-bottom: 3px;
      .task-key {
        text-align: right;
        width: 80px;
        color: rgba(0, 0, 0, 0.45);
      }
      .task-value {
        flex: 1;
        color: rgba(0, 0, 0, 0.85);
        margin-left: 4px;
      }
    }
    .flex-end {
      margin-top: 6px;
      display: flex;
      justify-content: end;
    }
  }
}
.task-info-dialog {
  .el-dialog__body {
    padding: 24px;
  }
  .wrap-files {
    .task-flex {
      display: flex;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 16px;
      .task-key {
        text-align: right;
        width: 80px;
        color: rgba(0, 0, 0, 0.45);
      }
      .task-value {
        flex: 1;
        color: rgba(0, 0, 0, 0.85);
        margin-left: 6px;
      }
    }
  }
}
</style>
